module.exports = __webpack_public_path__ + "static/media/qualdigiin_logo.53c8d645.png";